<template>
    <div class="new-cell-group">
        <van-tabs v-model="tabIndex" :sticky="true">
            <van-tab v-for="(tabItem, tabIndex) in tabList" :title="tabItem.title" :key="tabIndex">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-empty v-if="couponList.length <= 0" description="暂无数据" />
                    <van-list v-else :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad" >
                        <coupon v-for="(couponItem, couponIndex) in couponList" :key="couponIndex" :coupon-info="couponItem" @click="couponClick" style="margin: 10px;" />
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>

        <van-popup v-model="couponDetailShow" position="bottom" round  :style="{ height: '90%', backgroundColor : '#f6f6f6' }">
            <div class="base-flex-center">
                <coupon :coupon-info="couponDetail" style="margin-top: 1rem;width: 90%;" />
            </div>
            <van-cell-group style="margin: 30px 0;">
                <van-cell title="兑换码" :value="couponDetail.coupon.code" />
                <van-cell>
                    <template #title>
                        <div style="width: 200px; margin: auto;">
                            <qriously :value="couponDetail.coupon.code" :size="200" :foreground-alpha="couponDetail.status === '0' ? 1 : 0.3" />
                        </div>
                    </template>
                </van-cell>
                <van-cell title="适用场景" :value="$store.state.systemEnum['company']['coupon_template']['use_scene'][couponDetail.coupon.template.use_scene]" />

                <template v-if="couponDetail.coupon.template.use_scene === 'consume'">
                    <van-cell title="可用站点">
                        <template #label>
                            {{canUseSite}}
                        </template>
                    </van-cell>
                    <van-cell title="可加油品">
                        <template #label>
                            {{canUseOilType}}
                        </template>
                    </van-cell>
                </template>
                <van-cell v-if="couponDetail.coupon.template.explain" title="说明">
                    <template #label>
                        {{couponDetail.coupon.template.explain}}
                    </template>
                </van-cell>
            </van-cell-group>
        </van-popup>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import Coupon from "./Coupon";

    export default {
        name: "Index",
        components: {Coupon},
        data(){
            return {
                tabList : [
                    {
                        title : '待使用',
                        status : '0',
                    },
                    {
                        title : '已使用',
                        status : '1',
                    },
                    {
                        title : '已过期',
                        status : '2',
                    },
                ],
                tabIndex : 0,
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 15,
                },
                couponList : [],
                couponDetailShow : false,
                couponDetail : {
                    coupon : {
                        template : {
                            use_scene_rule_info : {},
                        },
                    },
                },
            };
        },
        watch : {
            tabIndex(newValue, oldValue){
                this.onRefresh();
            },
        },
        computed : {
            canUseSite(){
                if(!this.couponDetail.coupon.template.use_scene_rule_info.site) return '';
                let site = this.couponDetail.coupon.template.use_scene_rule_info.site;
                let siteArr = [];
                for(let index in site){
                    siteArr.push(site[index]['name']);
                }
                return siteArr.join('、');
            },
            canUseOilType(){
                if(!this.couponDetail.coupon.template.use_scene_rule_info.oil_type) return '';
                let oilType = this.couponDetail.coupon.template.use_scene_rule_info.oil_type;
                let oilTypeArr = [];
                for(let index in oilType){
                    oilTypeArr.push(oilType[index]['name']);
                }
                return oilTypeArr.join('、');
            },
        },
        created() {
            this.onRefresh();
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/coupon/list', Object.assign({}, self.params, {
                    'status' : this.tabList[this.tabIndex]['status'],
                })).then(res => {
                    if(self.params.page >= res.data.max_page){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.couponList = [];
                    }

                    for(let index in res.data.data){
                        self.couponList.push(res.data.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
            couponClick(detail){
                this.couponDetail = detail;
                this.couponDetailShow = true;
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            /deep/ .van-tabs__line {
                background-color: themed('colorTag');
            }

            /deep/ .van-tab--active {
                color: themed('colorText')
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/coupon/Index.vue